import * as React from 'react';
import { useSelector } from 'react-redux';

import { ChatList } from '../../components/ChatList';
import { ChatListSupportItem } from '../../components/ChatListSupportItem';
import { useFeedbackForm } from '../../hooks/useFeedbackForm';
import { currentOpenChatIDSelector, hostTypeSelector, selectChatListStatus, selectCurrentRoute } from '../../selectors';
import { IChat } from '../../types/chatList';
import { ERoute } from '../../types/route';
import { isIframeHostType } from '../../utils/isIframeHostType';
import { LeftSwipeVisibleProvider } from '../../utils/useLeftSwipeVisible';
import { ChatListChatbotItemContainer } from '../ChatListChatbotItemContainer';
import { ChatListItemContainer } from '../ChatListItemContainer';

interface IChatListContentContainerProps {
  onScrollToEnd: VoidFunction;
  chats: IChat[];
  listRef: React.RefObject<HTMLDivElement | null>;
  openedChatRef: React.RefObject<HTMLDivElement | null>;
}

export const ChatListContentContainer: React.FC<IChatListContentContainerProps> = ({
  onScrollToEnd,
  chats,
  listRef,
  openedChatRef,
}) => {
  const { requestFeedbackForm } = useFeedbackForm();
  const hostType = useSelector(hostTypeSelector);
  const chatListStatus = useSelector(selectChatListStatus);
  const isFrame = isIframeHostType(hostType);
  const currentRoute = useSelector(selectCurrentRoute);
  const currentOpenChatId = useSelector(currentOpenChatIDSelector);

  return (
    <ChatList status={chatListStatus} onScrollToEnd={onScrollToEnd} ref={listRef}>
      <LeftSwipeVisibleProvider>
        {currentRoute === ERoute.Messages && (
          <>
            {!isFrame && <ChatListSupportItem onClick={requestFeedbackForm} />}
            <ChatListChatbotItemContainer />
          </>
        )}

        {chats.map(chat => (
          <ChatListItemContainer
            chat={chat}
            key={`chat-item-${chat.chatId}`}
            openedChatRef={openedChatRef}
            isActive={chat.chatId === currentOpenChatId}
          />
        ))}
      </LeftSwipeVisibleProvider>
    </ChatList>
  );
};
